/**
 PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA

 *  Copyright © 2017 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
* */

import React from 'react';
import PropTypes from 'prop-types';
import Card from '@material-ui/core/Card';

/**
 * Feedback: A Component to show popover for dropdown
 *
 * @author Phanichander Katakam
 */

class Popover extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const top = document.getElementById(this.props.id).getBoundingClientRect().top - 2;
    const left = (document.getElementById(this.props.id).getBoundingClientRect().left + 148);

    return (
      <span role="presentation" className="popup-overlay" onClick={this.props.hidePopup}>
        <Card className="popover-container" style={{ top: `${top}px`, left: `${left}px` }}>
          {this.props.children}
        </Card>
      </span>
    );
  }
}

Popover.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
  hidePopup: PropTypes.func
};

export default Popover;



// WEBPACK FOOTER //
// ./src/js/components/Popover/Popover.jsx